import React, { Component } from "react";
import styled from "styled-components";
import { connect } from 'react-redux'
import { FastField } from 'formik'
import moment from "moment";
import { isEmpty } from 'lodash'

// Users Columns
import Helper from "../../../helper/helper";
import SoLieu from './SoLieumobile'


import Bieudocotmobile from "../Bieudocotmobile";


import message from "../../../components/Messages";
import Api_tnn from '../../../api/api.tnn';
import Api_quantrac from '../../../api/api.quantrac'
import { Card, Col, Row, Layout } from "antd";
import Clock from 'react-live-clock';
import Container from "../../../containers/Container";
import { LineChart, Line, AreaChart, Area, Brush, XAxis, YAxis, CartesianGrid, Tooltip, BarChart, Legend, Bar, ResponsiveContainer } from 'recharts'
import SoLieuBieuDomobile from "./SoLieuBieuDomobile";


let date = moment().locale("vi").format('L');
let day = moment().locale("vi").format('dddd');

class ThongKeMB extends Component {
  constructor(props) {
    super(props);
    const { functions } = props;
    this.state = {
      data_bieudo: [],
      data_bieudobcdk: [],
      loading: true
    };

  }


  componentDidMount() {
    this.GetTongGP();
  }
  componentDidUpdate(prevProps, prevState, snapshot) {

  }

  GetTongGP = async () => {
    try {
      const data = await new Api_tnn().GetTongSo_GP({ token: this.props.user.access_token })
      const dataquantrac = await new Api_quantrac().tongso_gp({ token: this.props.user.access_token })

      if (data && dataquantrac) {
        // Giay phep xa thai
        let data_xathai_GP = [
          { name: 'Còn hiệu lực', value: data.count_xnt_hl - data.count_xnt_shhl, backGroundColor: "#52c41a", value_tong: data.count_xnt, tittle_tong: "Tổng số", tittle_cgbc: "Chưa gửi báo cáo" },
          { name: 'Sắp hết hiệu lực', value: data.count_xnt_shhl, backGroundColor: "#faad14" },
          { name: 'Hết hiệu lực', value: data.count_xnt_hhl, backGroundColor: "#f5222d" },
        ]
        let data_xathai_BCDK = [
          { indicatorbcdk: 'Bình thường', value_bcdk: data.count_xnt_baocao_binhthuong, backGroundColor: "#52c41a", value_tong_bcdk: data.count_xnt_baocao, tittle_tong_bcdk: "Tổng số " },
          { indicatorbcdk: 'Chờ phê duyệt', value_bcdk: data.count_xnt_baocao_chopheduyet, backGroundColor: "#ecd200" },
          { indicatorbcdk: 'Vượt ngưỡng', value_bcdk: data.count_xnt_baocao_vuotchiso, backGroundColor: "#f5222d" },
          { indicatorbcdk: 'Chưa đánh giá', value_bcdk: data.count_xnt_baocao_chuadanhgia, backGroundColor: "#faad14" },
        ]

        let data_gp_xt = {
          giayphep: data_xathai_GP,
          baocaodinhky: data_xathai_BCDK,
          tittle: "NƯỚC XẢ THẢI",
          tieude: "Giấy Phép",
          chuaguibc: data.count_xnt_chuaguibaocao
        }
        //giay phep nuoc mat
        let data_nuocmat_GP = [
          { name: 'Còn hiệu lực ', value: data.count_nm_hl - data.count_nm_shhl, backGroundColor: "#52c41a", value_tong: data.count_nm, tittle_tong: " Tổng số", tittle_cgbc: " Chưa gửi báo cáo", },
          { name: 'Sắp hết hiệu lực ', value: data.count_nm_shhl, backGroundColor: "#faad14" },
          { name: 'Hết hiệu lực ', value: data.count_nm_hhl, backGroundColor: "#f5222d" },
        ]
        let data_nuocmat_BCDK = [
          { indicatorbcdk: 'Bình thường', value_bcdk: data.count_nm_baocao_binhthuong, backGroundColor: "#52c41a", value_tong_bcdk: data.count_nm_baocao, tittle_tong_bcdk: "Tổng số  " },
          { indicatorbcdk: 'Chờ phê duyệt', value_bcdk: data.count_nm_baocao_chopheduyet, backGroundColor: "#ecd200" },
          { indicatorbcdk: 'Vượt ngưỡng', value_bcdk: data.count_nm_baocao_vuotchiso, backGroundColor: "#f5222d" },
          { indicatorbcdk: 'Chưa đánh giá', value_bcdk: data.count_nm_baocao_chuadanhgia, backGroundColor: "#faad14" },
        ]
        let data_gp_nm = {
          giayphep: data_nuocmat_GP,
          baocaodinhky: data_nuocmat_BCDK,
          tittle: "NƯỚC MẶT",
          tieude: "Giấy Phép",
          chuaguibc: data.count_nm_chuaguibaocao
        }
        // giay phep nuoc dd
        let data_nuocdd_GP = [
          { name: ' Còn hiệu lực', value: data.count_ndd_hl - data.count_ndd_shhl, backGroundColor: "#52c41a", value_tong: data.count_ndd, tittle_tong: "  Tổng số", tittle_cgbc: "  Chưa gửi báo cáo" },
          { name: ' Sắp hết hiệu lực', value: data.count_ndd_shhl, backGroundColor: "#faad14" },
          { name: ' Hết hiệu lực', value: data.count_ndd_hhl, backGroundColor: "#f5222d" },
        ]
        let data_nuocdd_BCDK = [
          { indicatorbcdk: 'Bình thường', value_bcdk: data.count_ndd_baocao_binhthuong, backGroundColor: "#52c41a", value_tong_bcdk: data.count_nm_baocao, tittle_tong_bcdk: "Tổng số   " },
          { indicatorbcdk: 'Chờ phê duyệt', value_bcdk: data.count_ndd_baocao_chopheduyet, backGroundColor: "#ecd200" },
          { indicatorbcdk: 'Vượt ngưỡng', value_bcdk: data.count_ndd_baocao_vuotchiso, backGroundColor: "#f5222d" },
          { indicatorbcdk: 'Chưa đánh giá', value_bcdk: data.count_ndd_baocao_chuadanhgia, backGroundColor: "#faad14" },
        ]
        let data_gp_ndd = {
          giayphep: data_nuocdd_GP,
          baocaodinhky: data_nuocdd_BCDK,
          tittle: "NƯỚC DƯỚI ĐẤT",
          tieude: "Giấy Phép",
          chuaguibc: data.count_ndd_chuaguibaocao
        }
        // DTM
        let data_dtm_qdpd = [
          { name: "", name_1: 'Quyết định phê duyệt', value_qd: dataquantrac.count_dtm },
        ]
        let data_dtm_bcdk = [
          { name: "", indicatorbcdk: 'Bình thường', value_bcdk: dataquantrac.count_dtm_bcdk_binhthuong, backGroundColor: "#52c41a", value_tong_bcdk: dataquantrac.count_dtm_bcdk, tittle_tong_bcdk: " Tổng số " },
          { name: "", indicatorbcdk: 'Chờ phê duyệt ', value_bcdk: dataquantrac.count_dtm_bcdk_chopheduyet, backGroundColor: "#ecd200" },
          { name: "", indicatorbcdk: 'Vượt ngưỡng', value_bcdk: dataquantrac.count_dtm_bcdk_vuotchiso, backGroundColor: "#f5222d" },
          { name: "", indicatorbcdk: 'Chưa đánh giá', value_bcdk: dataquantrac.count_dtm_bcdk_chuadanhgia, backGroundColor: "#faad14" },
        ]

        let data_dtm = {
          giayphep: data_dtm_qdpd,
          baocaodinhky: data_dtm_bcdk,
          tittle: "ĐTM",
          tieude: undefined,
          chuaguibc: undefined
        }
        //BVMT
        let data_bvmt_qdpd = [
          { name: "", name_1: ' Quyết định phê duyệt', value_qd: dataquantrac.count_bvmt },
        ]
        let data_bvmt_bcdk = [
          { name: "", indicatorbcdk: 'Bình thường', value_bcdk: dataquantrac.count_bvmt_bcdk_binhthuong, backGroundColor: "#52c41a", value_tong_bcdk: dataquantrac.count_bvmt_bcdk, tittle_tong_bcdk: " Tổng số  " },
          { name: "", indicatorbcdk: 'Chờ phê duyệt  ', value_bcdk: dataquantrac.count_bvmt_bcdk_chopheduyet, backGroundColor: "#ecd200" },
          { name: "", indicatorbcdk: 'Vượt ngưỡng', value_bcdk: dataquantrac.count_bvmt_bcdk_vuotchiso, backGroundColor: "#f5222d" },
          { name: "", indicatorbcdk: 'Chưa đánh giá', value_bcdk: dataquantrac.count_bvmt_bcdk_chuadanhgia, backGroundColor: "#faad14" },
        ]

        let data_bvmt = {
          giayphep: data_bvmt_qdpd,
          baocaodinhky: data_bvmt_bcdk,
          tittle: "THỦ TỤC MÔI TRƯỜNG KHÁC",
          tieude: undefined,
          chuaguibc: undefined
        }


        let data_all = [data_gp_xt, data_gp_nm, data_gp_ndd, data_dtm, data_bvmt]
        this.setState({
          data_bieudo: data_all,
          datatong: data,
          loading: false
        })

      }
    } catch (err) {
      message.error(err.message)
    }
  }
  render() {
    const {
      data_bieudo,
      datatong, loading
    } = this.state;
    const { user, functions } = this.props;
    return (
      <div>
        {loading ?
          <div>

          </div>
          :
          <Row style={{ background: "#eaecef" }}>
            {data_bieudo.length > 0 && data_bieudo && data_bieudo.map((item, idx) =>
              <Col xs={24} lg={12} xl={8} style={{ background: "#eaecef" }}>
                <div style={{ margin: 10 }} className="solieubieudo">
                  <SoLieuBieuDomobile data={item} functions={functions} history={this.props.history} datatong={datatong} />
                </div>
              </Col>
            )}
            <Col xs={24} lg={12} xl={8} style={{ background: "#eaecef" }}>
              <div style={{ margin: 10 }} className="solieubieudo">
                <SoLieu data={data_bieudo} />
              </div>
            </Col>
          </Row>
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.oidc.user,
  functions: state.functions
});

export default connect(mapStateToProps)(ThongKeMB);
